/* eslint max-classes-per-file: 0 */

import {
  Session as Data,
  SessionCollection as Collection,
} from '@/typings/api/CollectorPublication'

import { BaseCollectorApiAuth } from '@/api/BaseApiAuth'

export class SessionsApi extends BaseCollectorApiAuth<Data, Collection> {
  protected readonly endpoint = 'sessions';

  protected readonly hasFinishSlash = false;
}
